import "./App.css";
import SideBar from "./components/SideBar/SideBar";
import Header from "./components/Header/Header";
import Contents from "./components/Contents/Contents";
import SimpleBackdrop from "./components/Loader/Loader";
import { AppProvider } from "./store/AppContext";
import ResizeObserver from "resize-observer-polyfill";
import LoginScreen from "./views/Login/LoginScreen";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
  }

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup subscription
  }, []);

  return (
    <>
      <AppProvider>
        {user ? (
          <>
            <SideBar />
            <Header />
            <Contents />
          </>
        ) : (
          <LoginScreen />
        )}
        <SimpleBackdrop />
      </AppProvider>
    </>
  );
}

export default App;
